import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <div className="max-w-2xl mx-auto px-5 py-24 text-center">
        <XCircle weight="fill" size={64} className="text-secondary mx-auto mb-4" />
        <h1 className="font-heading text-4xl font-black tracking-tight">Pembayaran Dibatalkan</h1>
        <p className="text-zinc-400 mt-2">Transaksi dibatalkan. Anda dapat mencoba lagi kapan saja.</p>
        <Link to="/"><Button className="mt-6 bg-primary text-black font-bold hover:bg-cyan-300 rounded-none">Kembali ke Acara</Button></Link>
      </div>
    </div>
  );
}
